import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UpdateUserRequest, User } from './profile.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {}

  getUser(): Observable<User> {
    return this.http.get<User>('/v1/user-management/profile');
  }

  updateUserSettings(settings: UpdateUserRequest): Observable<User> {
    return this.http.put<User>('/v1/user-management/profile', settings);
  }
}
